import _ from 'lodash'
import util from '@/helper/util'
import emitter from '@/helper/emitter'
import { createApp } from 'vue'
import router from '@/router'
import store from '@/store'
import Main from '@/Main.vue'
import Select from '@/components/Select.vue'
import Image from '@/components/Image.vue'
import Modal from '@/components/BaseModal.vue'
window._ = _
util.construct()

var app = createApp(Main)
app.config.globalProperties.$_ = _
app.config.globalProperties.$emitter = emitter
app.config.globalProperties.$util = util
app.use(store).use(router).component('Select', Select).component('Image', Image).component('Modal', Modal)
app.mount('#app-container')
